import { ValidationInfo } from "./types";

// condition が true のオブジェクトがあれば、レスポンスとして返却する
export function checkValidation(
  validations: ValidationInfo[]
): ValidationInfo[] {
  return validations.filter(v => v.condition);
}
